import { floorParamTypesAPI, projectLinkAPI, paramLinkAPI } from "./api";

export const getFloorParamTypes = async (params) => {
  try {
    const res = await floorParamTypesAPI.getFloorParamTypes(params);
    return res?.data;
  } catch (e) {}
};

export const updateFloorParamType = async (body, params) => {
  try {
    const res = await floorParamTypesAPI.updateFloorParamType(body, params);
    return res?.data;
  } catch (e) {}
};

export const getParams = async (params) => {
  try {
    const res = await floorParamTypesAPI.getParams(params);
    return res?.data;
  } catch (e) {}
};

export const getUnits = async (params) => {
  try {
    const res = await floorParamTypesAPI.getUnits(params);
    return res?.data;
  } catch (e) {}
};

export const deleteFloorParamType = async (floor_param_type_id) => {
  try {
    const res = await floorParamTypesAPI.deleteFloorParamType(
      floor_param_type_id
    );
    return res?.data;
  } catch (e) {}
};

export const getProjectLinks = async (params) => {
  try {
    const res = await projectLinkAPI.getProjectLinks(params);
    return res?.data;
  } catch (e) {}
};

export const updateProjectLink = async (body, params) => {
  try {
    const res = await projectLinkAPI.updateProjectLink(body, params);
    return res?.data;
  } catch (e) {}
};

export const bulkUpdateProjectLink = async (body) => {
  try {
    const res = await projectLinkAPI.bulkUpdateProjectLink(body);
    return res?.data;
  } catch (e) {}
};

export const getFloorParamTypesForSelect = async (params) => {
  try {
    const res = await projectLinkAPI.getFloorParamTypesForSelect(params);
    return res?.data;
  } catch (e) {}
};

export const deleteProjectLink = async (floor_param_project_link_id) => {
  try {
    const res = await projectLinkAPI.deleteProjectLink(
      floor_param_project_link_id
    );
    return res?.data;
  } catch (e) {}
};

export const getParamLinks = async (params) => {
  try {
    const res = await paramLinkAPI.getParamLinks(params);
    return res?.data;
  } catch (e) {}
};

export const updateParamLink = async (body, params) => {
  try {
    const res = await paramLinkAPI.updateParamLink(body, params);
    return res?.data;
  } catch (e) {}
};

export const deleteParamLink = async (param_id) => {
  try {
    const res = await paramLinkAPI.deleteParamLink(param_id);
    return res?.data;
  } catch (e) {}
};

export const getFloorPlanTypes = async () => {
  try {
    const res = await paramLinkAPI.getFloorPlanTypes();
    return res?.data;
  } catch (e) {}
};

export const updateFloorPlanType = async (body) => {
  try {
    const res = await paramLinkAPI.updateFloorPlanType(body);
    return res?.data;
  } catch (e) {}
};

export const deleteFloorPlanType = async (param_id) => {
  try {
    const res = await paramLinkAPI.deleteFloorPlanType(param_id);
    return res?.data;
  } catch (e) {}
};

export const getParamTypes = async (floor_param_type_id) => {
  try {
    const res = await paramLinkAPI.getParamTypes(floor_param_type_id);
    return res?.data;
  } catch (e) {}
};

export const getParamValueLinks = async (param_id) => {
  try {
    const res = await paramLinkAPI.getParamValueLinks(param_id);
    return res?.data;
  } catch (e) {}
};

export const updateParamValueLink = async (body) => {
  try {
    const res = await paramLinkAPI.updateParamValueLink(body);
    return res;
  } catch (e) {}
};

export const deleteParamValueLink = async (param_value_link_id) => {
  try {
    const res = await paramLinkAPI.deleteParamValueLink(param_value_link_id);
    return res;
  } catch (e) {}
};

export const getParamValueLinkStat = async () => {
  try {
    const res = await paramLinkAPI.getParamValueLinkStat();
    return res?.data;
  } catch (e) {}
};

export const floorParamTypesColumns = [
  {
    name: "floor_param_type_id",
    field: "floor_param_type_id",
    label: "ID",
    align: "center",
    sortable: true,
  },
  {
    name: "floor_param_type_name",
    field: "floor_param_type_name",
    label: "Наименование",
    align: "left",
    headerStyle: "min-width: 250px",
    style: "min-width: 250px",
    sortable: true,
  },
  { name: "types", field: "types", label: "Типы", align: "left", headerStyle: "min-width: 400px; max-width: 600px;", style: "min-width: 400px; max-width: 600px;" },
  {
    name: "floor_param_type_code",
    field: "floor_param_type_code",
    label: "Код",
    align: "left",
    sortable: true,
  },
  {
    name: "weight",
    field: "weight",
    label: "Вес",
    align: "center",
    sortable: true,
  },
  {
    name: "floor_param_type_color",
    field: "floor_param_type_color",
    label: "Цвет",
    align: "center",
    sortable: true,
  },
  {
    name: "params",
    field: "params",
    label: "Параметры",
    align: "left",
    sortable: false,
    headerStyle: "min-width: 200px",
    style: "min-width: 200px",
  },
  {
    name: "unit_name",
    field: "unit_name",
    label: "Ед. изм.",
    align: "center",
    sortable: true,
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
  { name: "actions", field: "actions", label: "Действия", align: "center" },
  {
    name: "delete",
    label: "",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
];

export const projectLinkColumns = [
  {
    name: "floor_param_project_link_id",
    field: "floor_param_project_link_id",
    label: "ID",
    align: "center",
    sortable: true,
  },
  {
    name: "floor_param_type_name",
    field: "floor_param_type_name",
    label: "Параметр этажа",
    align: "left",
    sortable: true,
  },
  {
    name: "project_type_name",
    field: "project_type_name",
    label: "Тип проекта",
    align: "left",
    sortable: true,
  },
  { name: "actions", field: "actions", label: "Действия", align: "center" },
  {
    name: "delete",
    label: "",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
];

export const paramLinkColumns = [
  {
    name: "floor_param_type_param_link_id",
    field: "floor_param_type_param_link_id",
    label: "ID",
    align: "center",
    sortable: true,
  },
  {
    name: "floor_param_type_name",
    field: "floor_param_type_name",
    label: "Параметр этажа",
    align: "left",
    sortable: true,
  },
  {
    name: "param_name",
    field: "param_name",
    label: "Параметр планировки",
    align: "left",
    sortable: true,
  },
  { name: "actions", field: "actions", label: "Действия", align: "center" },
  {
    name: "delete",
    label: "",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
];

export const floorPlanTypesColumns = [
  {
    name: "param_id",
    field: "param_id",
    label: "ID",
    align: "center",
    sortable: true,
  },
  {
    name: "param_name",
    field: "param_name",
    label: "Наименование",
    align: "left",
    sortable: true,
  },
  {
    name: "param_code",
    field: "param_code",
    label: "Код",
    align: "left",
    sortable: true,
  },
  {
    name: "unit_id",
    field: "unit_id",
    label: "Ед. изм.",
    align: "center",
    sortable: true,
  },
  { name: "actions", field: "actions", label: "Действия", align: "center" },
  {
    name: "delete",
    label: "",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
];